'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedName from 'I18n/components/FormattedName';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import AgentAvatar from './AgentAvatar';
import OwnerActivationStatusTag from './OwnerActivationStatusTag';
import ReassignmentSelectInputPlaceholder from './ReassignmentSelectInputPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentValueButton = ({
  AsyncUIAvatar,
  avatar,
  away,
  email,
  firstName,
  lastName,
  loading,
  responder,
  text
}) => {
  const showPlaceholder = loading || !responder && text;
  if (showPlaceholder) return /*#__PURE__*/_jsx(ReassignmentSelectInputPlaceholder, {});
  const renderOwnerNameWithActivationTag = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedName, {
        givenName: firstName,
        familyName: lastName,
        email: email
      }), /*#__PURE__*/_jsx(OwnerActivationStatusTag, {
        activationStatus: responder.activationStatus
      })]
    });
  };
  const renderOwnerName = () => {
    return responder ? renderOwnerNameWithActivationTag() : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "routing-ui.reassignment.noOwnerUserOption"
    });
  };
  return /*#__PURE__*/_jsx(UIMediaObject, {
    align: "center",
    spacing: "extra-small",
    className: "reassignment-selected-agent",
    itemLeft: /*#__PURE__*/_jsx(AgentAvatar, {
      AsyncUIAvatar: AsyncUIAvatar,
      avatar: avatar,
      away: away,
      showStatus: Boolean(responder),
      size: "xs",
      style: {
        border: 'none'
      }
    }),
    children: /*#__PURE__*/_jsx("span", {
      className: "nowrap",
      "data-test-id": "reassignment-selected-agent",
      children: renderOwnerName()
    })
  });
};
ReassignmentValueButton.displayName = 'ReassignmentValueButton';
ReassignmentValueButton.propTypes = {
  AsyncUIAvatar: PropTypes.func.isRequired,
  avatar: PropTypes.string,
  away: PropTypes.bool,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  loading: PropTypes.bool,
  responder: PropTypes.object,
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default ReassignmentValueButton;